import moment from "moment-timezone";

export function formatSalesQuantity(quantity: number, locale: string | undefined): string {
  // Convert the quantity to an integer
  quantity = Math.floor(quantity);

  let formattedQuantity: number;

  // Implement the logic to format the quantity
  if (quantity === 0) {
    formattedQuantity = 0;
  } else if (quantity >= 100) {
    formattedQuantity = Math.floor(quantity / 100) * 100;
  } else if (quantity >= 10) {
    formattedQuantity = Math.floor(quantity / 10) * 10;
  } else {
    formattedQuantity = 1;
  }

  // Add commas for thousands separator
  const formattedQuantityWithCommas = formattedQuantity.toLocaleString(locale);

  return `${formattedQuantityWithCommas}+`;
}

// export function convertPromotionCodeValue(message: string): string {
//   // 정규식이 제대로 작동하는지 확인합니다.
//   const regex = /On order over USD (\d+(\.\d+)?), get USD (\d+(\.\d+)?)/;
//   const match = message.match(regex);

//   if (match) {
//       // 일치하는 값이 있으면, 각각의 값을 추출하여 새로운 형식으로 반환합니다.
//       const orderAmount = match[1];
//       const discountAmount = match[3];

//       return `US $${discountAmount} off over US $${orderAmount}`;
//   } else {
//       // 입력 문자열이 정규식과 일치하지 않으면, '?'를 반환합니다.
//       return '?';
//   }
// }
export function convertPromotionCodeValue(value: string): string {
  // comma를 기준으로 문자열을 분할합니다.
  const [orderPart, discountPart] = value.split(',');

  // orderPart에서 숫자만 추출하고 100을 곱하여 변환합니다.
  const orderAmount = parseInt(orderPart.match(/\d+\.\d+/)?.[0] || "0").toFixed(2);

  // discountPart에서 숫자만 추출하고 100을 곱하여 변환합니다.
  const discountAmount = parseInt(discountPart.match(/\d+\.\d+/)?.[0] || "0").toFixed(2);

  // 변환된 값을 문자열로 동적으로 결합합니다.
  return `US $${discountAmount} off over US $${orderAmount}`;
}

export function formatTimestampToSeoulTime(timestamp: number): string {
  // timestamp를 Asia/Seoul 타임존으로 변환하여 포맷팅
  const formattedDate = moment(timestamp).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss');
  
  return formattedDate;
}

export function formatPstToSeoulTime(date: string): string {
  console.log(`date: ${date}`);
  // 입력된 PST/PDT 시간 문자열을 moment 객체로 변환
  const pstDate = moment.tz(date, 'America/Los_Angeles');

  // 한국 시간대로 변환
  const kstDate = pstDate.clone().tz('Asia/Seoul');

  // 변환된 한국 시간을 'YYYY-MM-DD HH:mm:ss' 형식의 문자열로 반환
  return kstDate.format('YYYY-MM-DD HH:mm:ss');
}

export function convertCurrencySign(currency: string, price: string): string {
  // currency 변수에 따라 다른 통화 기호를 반환합니다.
  switch (currency) {
    // case 'USD':
    //   return '$';
    case 'KRW':
      return `${price}원`;
    case 'JPY':
      return `${price}円`;
    case 'EUR':
      return `${price} €`;
    case 'RUB':
      return `${price} ₽`;
    default:
      return `${price} ${currency}`;
  }
}